import { Component } from '@angular/core';

@Component({
  selector: 'centralizer, [centralizer]',
  templateUrl: './centralizer.component.html',
  styleUrls: [ './centralizer.component.scss' ],
})
export class CentralizerComponent { }
